import { useEffect } from 'react';

import { toTableData, sortUsers } from 'common/helpers/admin-page-func.helper';
import { UsersApi } from './api';
import { ActionCreators, Provider, useAdminState, useAdminDispatch } from './Context';
import { User } from 'common/types/user.type';
import { AdminLayout } from 'components/layouts';
import { useAdminParams } from 'common/hooks';
import Table from './Table';
import FormDialog from './FormDialog';
import DeleteDialog from './DeleteDialog';

let previousTableData:
  | null
  | (ReturnType<typeof toTableData<User>> & {
    shouldRefetch?: boolean;
  }) = null;

const UsersWrapper: React.FC = () => {
  useEffect(() => {
    return function cleanUp() {
      if (previousTableData) {
        previousTableData.shouldRefetch = true;
      }
    };
  }, []);

  return (
    <AdminLayout>
      <Provider>
        <Users />
      </Provider>
    </AdminLayout>
  );
};

const Users: React.FC = () => {
  const dispatch = useAdminDispatch();
  const { params: paramsState } = useAdminState();
  const params = useAdminParams<User>(paramsState.filter, paramsState.sort);

  useEffect(() => {
    if (previousTableData) {
      dispatch(ActionCreators.loaded(previousTableData));
    }

    if (!params) return;

    if (!previousTableData) {
      dispatch(ActionCreators.loading());
    }

    UsersApi.get({ ...params, refetch: previousTableData?.shouldRefetch, sortFallback: sortUsers }).then((response) => {
      const tableData = toTableData(response);
      previousTableData = tableData;
      previousTableData.shouldRefetch = false;
      dispatch(ActionCreators.loaded(tableData));
    });
  }, [params, dispatch]);

  return (
    <>
      <Table />
      <FormDialog />
      <DeleteDialog />
    </>
  );
};

export default UsersWrapper;
